import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileUploadModel } from "../../../borrower-app/src/app/models/tasks/file-upload.model";

@Component({
    selector: 'file-list',
    templateUrl: './file-list.component.html',
    styleUrls: ['../file-upload.component.scss'],
    standalone: false
})
export class FileListComponent implements OnInit {
  @Input() files: FileUploadModel[] = [];
  @Input() isUploading: boolean = false;
  @Output() fileDeleted = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  deleteFile(index: number) {
    if (this.isUploading) {
      console.log("Upload in progress.");
      return;
    }
    this.files.splice(index, 1);
    this.fileDeleted.emit(index);
  }

  formatBytes(bytes: number, decimals = 2)
  {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
}
